import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { useCta } from '~publish/hooks/useCta'

import { FLOW_TRACKING } from '../components/InsightsUpgradeDialog/flows'

const { cta: CTA, upgradePathName: UPGRADE_PATH_NAME } = FLOW_TRACKING['export']

type UseInsightsExportUpgradeResult = {
  handleExportBlocked: () => void
}

export function useInsightsExportUpgrade(): UseInsightsExportUpgradeResult {
  const navigate = useNavigate()
  const cta = useCta(CTA, {
    upgradePathName: UPGRADE_PATH_NAME,
  })

  const handleExportBlocked = useCallback((): void => {
    cta.clicked()
    navigate('/settings/billing')
  }, [cta, navigate])

  return { handleExportBlocked }
}
